import { Link, useLocation } from "react-router-dom";
import { Compass, Home, Trophy, User, Users } from "lucide-react";

const PILOT_MODE = process.env.REACT_APP_PILOT_MODE !== "false";

const ITEMS = [
  { to: "/", label: "Start", icon: Home, testId: "nav-start" },
  { to: "/wege", label: "Wege", icon: Compass, testId: "nav-wege" },
  { to: "/challenges", label: "Challenges", icon: Trophy, testId: "nav-challenges" },
  { to: "/spielen", label: "Spielen", icon: Users, testId: "nav-spielen" },
  { to: "/profil", label: "Profil", icon: User, testId: "nav-profil" },
];

export function BottomNav() {
  const { pathname } = useLocation();
  const visibleItems = PILOT_MODE ? ITEMS.filter((item) => ["/", "/wege", "/profil"].includes(item.to)) : ITEMS;
  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-40 border-t bg-[rgba(248,245,238,0.92)] backdrop-blur-xl"
      data-testid="bottom-nav"
      aria-label="Hauptnavigation"
      style={{ paddingBottom: "env(safe-area-inset-bottom, 0px)" }}
    >
      <div className="mx-auto flex max-w-2xl items-stretch justify-between px-2 py-1.5">
        {visibleItems.map(({ to, label, icon: Icon, testId }) => {
          const active = to === "/" ? pathname === "/" : pathname.startsWith(to);
          return (
            <Link
              key={to}
              to={to}
              data-testid={testId}
              aria-current={active ? "page" : undefined}
              className="flex flex-1 flex-col items-center gap-0.5 rounded-xl px-1 py-1.5 transition-colors"
              style={{ color: active ? "var(--brand)" : "var(--ink-soft)" }}
            >
              <Icon className="h-5 w-5" strokeWidth={active ? 2.4 : 1.7} />
              <span className="text-xs font-semibold tracking-wide">{label}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}

export default BottomNav;
